var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.892578H513V342.893H0V0.892578Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 234.393H513V285.393H0V234.393Z",
    fill: "#F9E814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7 87.3926L181.6 127.193H223.4L189.6 151.693L202.5 191.393L168.7 166.893L134.9 191.393L147.8 151.693L114 127.193H155.8L168.7 87.3926ZM85.4 33.3926L93.2 57.2926H118.2L97.9 71.9926L105.7 95.7926L85.4 81.0926L65.1 95.7926L72.9 71.9926L52.6 57.2926H77.7L85.4 33.3926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/CW.26e45bd6b0def397a331db689b1836a4.svg";
export { ForwardRef as ReactComponent };